<template lang="pug">
  .form
    sleeping-house-editor-modal(
    v-if="showSleepingHouseEditorModal"
    @close="showSleepingHouseEditorModal = false"
    :sleeping-houses-names="sleepingHousesNames"
    :current-sleeping-house="currentSleepingHouse"
    :current-sleeping-house-index="currentSleepingHouseIndex"
    :camp-data="campData"
    @add-sleeping-house="addSleepingHouse"
    @update-sleeping-house="updateSleepingHouse"
    )
    .form__elem(
    v-for="(house, index) in sleepingHouses"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title
        .form-elem__body
          .attached-item
            a.button(
            @click.prevent.stop="onCampHouseClick(house, index)"
            )
              .button__text {{ house.name.text }}
            button-delete(
            @on-button-click="onButtonDeleteClick(index)"
            )
    .form__elem
      .form-elem.form-elem_right
        .form-elem__title
        .form-elem__body
          button.button.button_paint-main--light.button_narrow(
          @click.prevent="onAddSleepingHouse"
          )
            .button__text Добавить спальный корпус
</template>

<script>

import ButtonDelete from "../../../../../../components/button-delete/ButtonDelete";
import SleepingHouseEditorModal from "../../../../../../components/modals/SleepingHouseEditorModal";
export default {
  name: "ManagerCampPlacementSleepingHouses",
  components: {SleepingHouseEditorModal, ButtonDelete},
  props: {
    sleepingHouses: {
      type: Array,
      default: () => ([])
    },
    sleepingHousesNames: {
      type: Array,
      default: () => ([])
    },
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showSleepingHouseEditorModal: false,
      currentSleepingHouse: null,
      currentSleepingHouseIndex: null
    };
  },
  methods: {
    onCampHouseClick(house, index) {
      this.currentSleepingHouse = house;
      this.currentSleepingHouseIndex = index;
      this.showSleepingHouseEditorModal = true;
    },
    onButtonDeleteClick(index) {
      this.$emit("delete-sleeping-house", index);
    },
    onAddSleepingHouse() {
      this.currentSleepingHouse = null;
      this.currentSleepingHouseIndex = null;
      this.showSleepingHouseEditorModal = true;
    },
    addSleepingHouse(data) {
      this.$emit("add-sleeping-house", data);
    },
    updateSleepingHouse(data, index) {
      this.$emit("update-sleeping-house", data, index);
    }
  }
};
</script>
